







import Vue from 'vue'
import { DialNumberElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'DialNumberEl',

  props: {
    templateItemData: {
      type: Object as () => DialNumberElInterface,
      required: true
    }
  }
})
